module.exports = __webpack_public_path__ + "img/bgIcon_5.0f09624c.png";